import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import PeriodRevenueOverview from 'widgets/smartviews/partials/PeriodRevenueOverview'
import { WhenModel } from '@morningtrain/react-resources'
import ScheduleSmartViewTabs from 'widgets/smartviews/shifts/ScheduleSmartViewTabs'
import { Translator } from '@morningtrain/react-translations'

function SchedulePeriodSummarySmartview (props) {
  return (
    <Translator namespace='smartviews.schedule_period_summary'>
      <WhenModel>
        <Smartview>
          <ScheduleSmartViewTabs active='period_summary' />
          <PeriodRevenueOverview />
        </Smartview>
      </WhenModel>
    </Translator>
  )
}

export default SchedulePeriodSummarySmartview
